<template>
  <span>
    <el-dialog
    title="查看"
    :close-on-click-modal="false"
    :visible.sync="viewDetailFlag"
    @close="viewDetailFlag=false;viewForm={};tableData=[];"
    append-to-body
    width="65%">
        <!-- <div>新增详情：{{query.projectId}}</div> -->
        <avue-form 
        style="height: 50vh;overflow: scroll;" ref="viewForm" v-if="viewDetailFlag" v-model="viewForm" :option="option" @reset-change="emptytChange" @submit="submit">
            
  <!-- <template slot="menuForm">
    <el-button  icon="el-icon-delete" @click="viewDetailFlag=false;viewForm={};tableData=[];">取 消</el-button>
  </template> -->
   <template slot-scope="{}" slot="checkItemLabel">
       <div>{{' '}}</div>
   </template>
   <template slot-scope="scope" slot="userIdList">
       <!-- :limit="1" -->
              <UserEditBox2
                v-model="viewForm.userIdList"
                :remainUserListInside.sync="remainUserList"
                :projectId="viewForm.projectId"
                :disabled="pageMode == 0"
              />
   </template>
            <template slot-scope="{}" slot="checkItem">
                <div>
                    <el-table border :data="tableData">
                        <el-table-column
                        align="center"
                        header-align="center"
                        label="#"
                        type="index">
                        </el-table-column>
                        <el-table-column
                        prop="content"
                        label="标准内容"
                        width="280">
                        </el-table-column>
                        <el-table-column
                        prop="demand"
                        label="考核要求"
                        width="180">
                        </el-table-column>
                        <el-table-column
                        prop="score"
                        label="分值">
                        </el-table-column>
                        <el-table-column
                        prop="baseScore"
                        label="基准分值">
                        </el-table-column>
                    </el-table>
                </div>
            </template>
        </avue-form>
    </el-dialog>
        <el-button
            type="text"
            size="small"
            icon=""
            style="padding:0 .1rem"
            @click="viewDetailFlag=true;initPage()"
        >
          查看     
        </el-button>
  </span>
</template>

<script>
import { add, getAllUserByTaskId, getDetail, getList, remove, update, getProjectDic,getStandardNameList,getStandardInfo,getStandardDetailList,getStandardDetailList_ } from '@/api/v4ward/assess/task/assesstask';
import {getProjectList} from "@/api/crmedical/group/group";
        import { getDictionary } from '@/api/common';
import UserEditBox2 from "@/views/components/user-edit-box2";
export default {
    
  components: { UserEditBox2 },
  props: {
    query: {
      default: ()=>{}, //项目id
    },
    row: {
      default: ()=>{}, //项目id
    },
  },

    data(){
        let disabled = true;
        return{
            pageMode:0,
            remainUserList:[],
            viewForm:{},
            viewDetailFlag:false,
            tableData:[],
      option: {
        //   mockBtn:true,
          submitText: '保存',
          cancelBtn:false,
          submitBtn:false,
        emptyBtn:false,
        //   printBtn:true,
        column: [
          // {
          //   label: '主键',
          //   prop: 'id',
          //   rules: [
          //     {
          //       required: true,
          //       message: '请输入主键',
          //       trigger: 'change',
          //     },
          //   ],
          // },
          {
            // label: '项目id',
            disabled: disabled,
            label: '项目名称',
            prop: 'projectId',
            searchValue:'66666',
            type:'select',
            span:8,
            props:{
              label:'name',value:'id'
            },
            // bind:'query.projectId',
            change:(value,column)=>{
              console.log(value,column);
              this.viewForm.projectId = value.value;
              if(value.value){
                  this.getDicData(value.value);
              }
            },
            dicData:[],
            // bind:'query.projectId',
            // change:(value,column)=>{
            //   console.log(value,column);
            //   this.query.projectId = value.value;
            // },
            rules: [
              {
                required: true,
                message: '请输入项目名称',
                trigger: 'change',
              },
            ],
          },
          {
            disabled: disabled,
            // label: "考核对象类型,取自项目字典project_assess_object_type",
            label: '考核对象',
            prop: 'objectType',
            search: true,
            span:8,
            type:'select',
            props:{
              label:'dictValue',value:'dictKey'
            },
            dicData:[],
            change:(value,column)=>{
              console.log(value,column);
              this.viewForm.objectType = value.value;
              if(value.value){
                this.getStandardNameData(value.value,this.viewForm.projectId);
              }
            },
            rules: [
              {
                required: true,
                // message: '请输入考核对象类型,取自项目字典project_assess_object_type',
                message: '请输入考核对象类型',
                trigger: 'change',
              },
            ],
          },
          
          {
            disabled: disabled,
            // label: '标准id',
            label: '标准名称',
            prop: 'standardName',
            span:8,
            type:'input',
          },
          {
            display: false,
            disabled: disabled,
            // label: '标准id',
            label: '标准名称',
            prop: 'standardId',
            span:8,
            type:'select',
            props:{
              label:'name',value:'id'
            },
            dicData:[],
            change:(value,column)=>{
              console.log(value,column);
              this.viewForm.standardId = value.value;
              if(value.value){
                  this.getStandardInfoData(value.value);
                  this.getStandardDetailListData(value.value);
              }
            },
            rules: [
              {
                required: true,
                // message: '请输入标准id',
                message: '请输入标准名称',
                trigger: 'change',
              },
            ],
          },
          {
            disabled: disabled,
            label: '任务名称',
            prop: 'name',
            search: true,
            maxlength:'50',
            showWordLimit:true,
            type:'input',
            span:24,
            rules: [
              {
                required: true,
                message: '请输入任务名称',
                trigger: 'change',
              },
            ],
          },
          {
            disabled: true,
            label: '总分',
            prop: 'totalScore',
            span:8,
            // rules: [
            //   {
            //     required: true,
            //     message: '请输入总分',
            //     trigger: 'change',
            //   },
            // ],
          },
          {
            disabled: true,
            label: '基准分',
            prop: 'baseScore',
            span:8,
            // rules: [
            //   {
            //     required: true,
            //     message: '请输入基准分',
            //     trigger: 'change',
            //   },
            // ],
          },
          {
            disabled: true,
            // label: '关联合同id',
            label: '合同名称',
            prop: 'contractName',
            span:8,
            // rules: [
            //   {
            //     required: true,
            //     // message: '请输入关联合同id',
            //     message: '请输入合同名称',
            //     trigger: 'change',
            //   },
            // ],
          },
          {
            disabled: true,
            // label: '关联合同id',
            label: '合同编号',
            prop: 'contractCode',
            span:8,
            // rules: [
            //   {
            //     required: true,
            //     // message: '请输入关联合同id',
            //     message: '请输入合同编号',
            //     trigger: 'change',
            //   },
            // ],
          },
          {
            disabled: true,
            // label: '关联合同id',
            display:false,
            label: '合同Id',
            prop: 'contractId',
            span:8,
            // rules: [
            //   {
            //     required: true,
            //     // message: '请输入关联合同id',
            //     message: '请输入合同Id',
            //     trigger: 'change',
            //   },
            // ],
          },
          {
            disabled: disabled,
            // label: '通知方式（多选）：1-系统消息；2-短信；3-微信；',
            label: '通知方式',
            prop: 'systemNotifyWays_',
            span:8,
            type:'select',
            props:{
              label:'dictValue',value:'dictKey'
            },
            multiple:true,
            dicData:[],
            change:(value,column)=>{
              console.log(value,column);
              if(value.value){
              this.viewForm.systemNotifyWays = value.value.join(',');
              }
            //   this.getStandardInfoData(value.value);
            },
            rules: [
              {
                required: true,
                // message: '请输入通知方式（多选）：1-系统消息；2-短信；3-微信；',
                message: '请输入通知方式',
                trigger: 'change',
              },
            ],
          },
          {
            disabled: disabled,
            label: '任务时间',
            prop: 'taskTime',
            type: 'datetimerange',
            rangeSeparator:'至',
            startPlaceholder:'开始时间',
            endPlaceholder:'结束时间',
            span:16,
            valueFormat:'yyyy-MM-dd HH:mm:ss',
            change:(value,column)=>{
              console.log(value,column);
              this.viewForm.startTime = value.value[0];
              this.viewForm.endTime = value.value[1];
            //   this.getStandardInfoData(value.value);
            },
            rules: [
              {
                required: true,
                message: '请输入任务时间',
                trigger: 'change',
              },
            ],
          },
          {
            disabled: disabled,
            label: '考评人员',
            prop: 'userIdList',
              formslot:true,
            // type: 'datetime',
            span:16,
            rules: [
              {
                required: true,
                message: '请输入考评人员',
                trigger: 'change',
              },
            ],
          },
          {
            disabled: disabled,
            label: '备注',
            prop: 'description',
            type: 'textarea',
            maxlength:'500',
            span:24,
            showWordLimit:true,
            // rules: [
            //   {
            //     required: true,
            //     message: '请输入考评人员',
            //     trigger: 'change',
            //   },
            // ],
          },
          {
            label: '考核项目',
            prop: 'checkItem',
            // type: 'datetime',
              formslot:true,
            //   labelslot:true,
            labelPosition:'top',
            span:24,
            rules: [
              {
                required: true,
                message: '请输入考评人员',
                trigger: 'change',
              },
            ],
          },
        //   {
        //     label: '结束时间',
        //     prop: 'endTime',
        //     span:8,
        //     rules: [
        //       {
        //         required: true,
        //         message: '请输入结束时间',
        //         trigger: 'change',
        //       },
        //     ],
        //   },
        //   {
        //     // label: '任务状态 0-未开始 1-进行中 2-已完成 3-已关闭 系统字典assess_task_work_status',
        //     label: '任务状态',
        //     prop: 'workStatus',
        //     span:8,
        //     search: true,
        //     rules: [
        //       {
        //         required: true,
        //         // message: '请输入任务状态 0-未开始 1-进行中 2-已完成 3-已关闭 系统字典assess_task_work_status',
        //         message: '请输入任务状态',
        //         trigger: 'change',
        //       },
        //     ],
        //   },
          // {
          //   label: '描述',
          //   prop: 'description',
          //   rules: [
          //     {
          //       required: true,
          //       message: '请输入描述',
          //       trigger: 'change',
          //     },
          //   ],
          // },
          // {
          //   label: '备注',
          //   prop: 'remark',
          //   rules: [
          //     {
          //       required: true,
          //       message: '请输入备注',
          //       trigger: 'change',
          //     },
          //   ],
          // },
          // {
          //   label: '版本',
          //   prop: 'version',
          //   rules: [
          //     {
          //       required: true,
          //       message: '请输入版本',
          //       trigger: 'change',
          //     },
          //   ],
          // },
        ],
      },
        }
    },

methods:{
    submit(done){
        add(this.viewForm).then((res)=>{
            console.log(res.data);
            this.$message.success('操作成功！');
            this.viewDetailFlag = false;
            this.viewForm = {};
            if(done){
                done();
            }
        });
    },
    getAllUserByTaskIdData(taskId){
        getAllUserByTaskId({taskId:taskId}).then((res)=>{
            console.log(res.data);
            let arr = res.data.map(item => item.userId);
            this.viewForm.userIdList = arr.join(',');
            this.remainUserList = res.data.map(item => {return {id:item.userId,realName:item.userName+"("+item.deptName+")"}});
        })
    },
    getStandardDetailListData(standardId){
        getStandardDetailList_({taskId:standardId}).then((res)=>{
            this.tableData = res.data;
            console.log("this.tableData=======>",this.tableData);
            this.viewForm.checkItem = res.data;
        });
    },
    getStandardInfoData(standardId){
        getStandardInfo({id:standardId}).then((res)=>{
            console.log(res);
            this.viewForm.contractName = res.data.contractName;
            this.viewForm.contractCode = res.data.contractCode;
            this.viewForm.contractId = res.data.contractId;
            this.viewForm.baseScore = res.data.baseScore;
            this.viewForm.totalScore = res.data.totalScore;
        })
    },
    getStandardNameData(objectType,projectId){
        getStandardNameList({objectType:objectType,projectId:projectId}).then((res)=>{
            this.setSearchFormDic('standardId',res.data);
        });
    },
    initPage(){
        console.log("this.$ref.viewForm====>",this.$refs.viewForm);
        // this.viewForm.projectId = this.query.projectId;
        getProjectList().then((res)=>{
        console.log(res);
        this.projectList = res.data;
        this.viewForm.projectId = this.row.projectId;
        this.viewForm.objectType = this.row.objectType+'';
        this.viewForm.standardId = this.row.standardId+'';
        this.viewForm.standardName = this.row.standardName+'';
        this.viewForm.systemNotifyWays_ = this.row.systemNotifyWays.split(',');
        this.viewForm.description = this.row.description;
        this.viewForm.taskTime = [new Date(this.row.startTime),new Date(this.row.endTime)];
        this.viewForm.name = this.row.name;
        // console.log(this.viewForm.systemNotifyWays_);
            // this.setSearchFormValue('crud','projectId',res.data[0].id);
            this.setSearchFormDic('projectId',res.data);
            this.getDicData(this.row.projectId);
            this.getAllUserByTaskIdData(this.row.id);
                  this.getStandardInfoData(this.row.standardId);
                  this.getStandardDetailListData(this.row.id);
        });
    },
    getDicData(projectId){
      getProjectDic({projectId:projectId,code:'project_examine_service_type'}).then((res)=>{
        this.setSearchFormDic('objectType',res.data);
      });
    //   system_notify_way
    getDictionary('system_notify_way').then((res)=>{
        this.setSearchFormDic('systemNotifyWays_',res.data);
      });
    //   getDictionary('assess_task_work_status').then((res)=>{
    //     this.setSearchFormDic('workStatus',res.data);
    //   });
    },
    setSearchFormDic(prop,list){
      const column = this.findObject(this.option.column, prop);
      column.dicData = list;
    },
    setSearchFormValue(ref,prop,value){
        setTimeout(()=>{
          this.$refs[ref].$refs.headerSearch.$refs.form.form[prop] = value;
        });
    },
},


}
</script>

<style>

</style>